ZoneObject.create('[data-section-live-past]', {
    run: () => {
        $(document).on('change', '[data-section-live-past] [name]', () => {
            items.update('live-past');
        });

        items.create({
            name: 'live-past',
            data: (obj) => {
                var data = {};

                if (typeof obj === 'object' && obj != null) {
                    data = $.extend(data, obj);
                }

                if ($('[data-section-live-past] [name="date"]:checked').length) {
                    data.date = $('[data-section-live-past] [name="date"]:checked').val();
                } else if ($('[data-section-live-past] [name="date[]"]:checked').length) {
                    data.date = [];
                    $('[data-section-live-past] [name="date[]"]:checked').each(function () {
                        data.date.push($(this).val());
                    });
                } else {
                    data.date = $('[data-section-live-past] [name="date"]').val();
                }

                if ($('[data-section-live-past] [name="location_id"]:checked').length) {
                    data.location_id = $('[data-section-live-past] [name="location_id"]:checked').val();
                } else {
                    data.location_id = $('[data-section-live-past] [name="location_id"]').val();
                }

                if ($('[data-section-live-past] [name="industry_id"]:checked').length) {
                    data.industry_id = $('[data-section-live-past] [name="industry_id"]:checked').val();
                } else {
                    data.industry_id = $('[data-section-live-past] [name="industry_id"]').val();
                }

                if ($('[data-section-live-past] [name="name"]').length) {
                    data.name = $('[data-section-live-past] [name="name"]').val();
                }

                return data;
            },
            first_load: true,
            html: (html, data) => {
                html.find('[html-image]').html('<img src="' + data.image + '"><div class="event-item__play-btn"></div>');

                if (data.industry != null) {
                    if (data.industry.id == 15) {
                        html.find('[html="industry.name"]').html('IT, ТВ, Мода, Кино, +10');
                    }

                    html.find('[attr-industry-color]').css('background', data.industry.color);
                }

                if (data.attendees != null) {
                    $.each(data.attendees, function (i, speaker) {
                        html.find('[html-speakers]').append((i ? ', ' : '') + speaker.name);
                    });

                    html.find('[html-speakers]').html('');

                    $.each(data.attendees, function (i, speaker) {
                        html.find('[html-speakers]').append((i > 0 ? ', ' : '') + speaker.name);

                        if (i == 1 && data.attendees_plus_mobile) {
                            html.find('[html-speakers]').append(', +' + data.attendees_plus_mobile);
                            return false;
                        }
                    });

                    html.find('[html-speakers-mobile]').parent().show();
                }

                return html;
            }
        });
    }
});